var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7996 5.59998H9.79961H6.99961C6.22641 5.59998 5.59961 6.22678 5.59961 6.99997V6.99998V9.79998V16.8C5.59961 17.5732 6.22641 18.2 6.99961 18.2H8.39961C9.17281 18.2 9.79961 17.5732 9.79961 16.8V9.79998H16.7996C17.5728 9.79998 18.1996 9.17317 18.1996 8.39997V6.99998C18.1996 6.22678 17.5728 5.59998 16.7996 5.59998Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2004 5.59998H46.2004H49.0004C49.7736 5.59998 50.4004 6.22678 50.4004 6.99997V6.99998V9.79998V16.8C50.4004 17.5732 49.7736 18.2 49.0004 18.2H47.6004C46.8272 18.2 46.2004 17.5732 46.2004 16.8V9.79998H39.2004C38.4272 9.79998 37.8004 9.17317 37.8004 8.39997V6.99998C37.8004 6.22678 38.4272 5.59998 39.2004 5.59998Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7996 51.8H9.79961H6.99961C6.22641 51.8 5.59961 51.1732 5.59961 50.4V50.4V47.6V40.6C5.59961 39.8268 6.22641 39.2 6.99961 39.2H8.39961C9.17281 39.2 9.79961 39.8268 9.79961 40.6V47.6H16.7996C17.5728 47.6 18.1996 48.2269 18.1996 49V50.4C18.1996 51.1732 17.5728 51.8 16.7996 51.8Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2004 51.8H46.2004H49.0004C49.7736 51.8 50.4004 51.1732 50.4004 50.4V50.4V47.6V40.6C50.4004 39.8268 49.7736 39.2 49.0004 39.2H47.6004C46.8272 39.2 46.2004 39.8268 46.2004 40.6V47.6H39.2004C38.4272 47.6 37.8004 48.2269 37.8004 49V50.4C37.8004 51.1732 38.4272 51.8 39.2004 51.8Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.2476 29.7902C38.7356 31.5961 38.2003 33.469 37.8978 35.1858C37.4556 37.7721 37.6185 39.9794 37.8047 41.228L24.7716 46.2V39.9348C24.7716 39.6004 24.6319 39.2882 24.3992 39.0653C24.1665 38.8423 23.8406 38.7085 23.4915 38.7085H18.7903C18.255 38.7085 17.8128 38.3072 17.8128 37.8167V32.8224C17.8128 32.1758 17.3008 31.6407 16.6259 31.5961L15.1131 31.4846C13.8331 31.3955 13.3909 31.3063 13.2978 31.284C12.5996 30.9718 12.5996 30.5482 12.5996 30.4144C12.5996 30.3699 12.7392 29.3665 15.951 25.7546L16.0673 25.6208C16.4164 25.2195 16.4164 24.8182 16.4164 24.0601V23.7034C16.4397 23.6142 16.4397 23.5473 16.4397 23.4581C16.463 17.8618 22.3744 12.6669 28.8211 12.6H28.9608C35.2446 12.6 40.5975 17.4828 40.5975 23.2351C40.644 24.9519 39.9225 27.4045 39.2476 29.7902Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NLP",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7968 22.3173V26.5999H19.4346V19.6223H20.6498L23.4134 23.8951V19.6223H24.7756V26.5999H23.5604L20.7968 22.3173ZM30.93 25.3847V26.5999H26.4024V19.6223H27.7646V25.3847H30.93ZM33.3993 26.5999V23.9735H34.7419C35.1012 23.9735 35.423 23.9163 35.7072 23.802C35.9914 23.6877 36.2331 23.5309 36.4324 23.3316C36.6317 23.1323 36.7836 22.9004 36.8881 22.6358C36.9926 22.3712 37.0449 22.0919 37.0449 21.7979C37.0449 21.5039 36.9926 21.2246 36.8881 20.96C36.7836 20.6954 36.6317 20.4635 36.4324 20.2642C36.2331 20.0649 35.9914 19.9081 35.7072 19.7938C35.423 19.6795 35.1012 19.6223 34.7419 19.6223H32.0371V26.5999H33.3993ZM33.3994 22.7485H34.6734C34.987 22.7485 35.2336 22.662 35.4133 22.4888C35.593 22.3157 35.6828 22.0854 35.6828 21.7979C35.6828 21.5105 35.593 21.2785 35.4133 21.1021C35.2336 20.9257 34.987 20.8375 34.6734 20.8375H33.3994V22.7485Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.0748736a188bee447a6725f4405f5d73.svg";
export { ForwardRef as ReactComponent };